@if (showLanguageSelectionButton == true) {
  <span class="menu-icon-link language-image-container" data-bs-toggle="offcanvas" data-bs-target="#sidebar-language">
    <img role="img" src="assets/images/flags/{{ currentLanguage!.flag }}.svg" [alt]="currentLanguage?.name" />
  </span>
}
